import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ConfigurationService } from "../configuration/configuration.service";
import { QualityBoostChartsResponse } from "./models/quality-boost-chart";
import { QualityBoostSummary } from "./models/quality-boost-summary";

// QualityBoostService is the clinical-ui read client for the QualityBoost
// Leadership Dashboard data contract (REQ-DASH-001/003). It calls the
// qualityboost-dashboard-api Lambda, which serves a tenant's PHI-free scoring
// summary and chart-tier list off the tier projection.
//
// Auth + tenant RBAC (REQ-UI-007/008) are enforced server-side by the API Gateway
// authorizer in front of the Lambda; the AuthorizationHttpInterceptor attaches the
// bearer token to every request here automatically, so this client carries no auth
// logic of its own.
@Injectable()
export class QualityBoostService {
  private readonly qualityBoostUrl: string;

  constructor(public http: HttpClient, private config: ConfigurationService) {
    // Mirror the qa-queue service's local-vs-deployed resolution: a local dev
    // override endpoint when isLocal, otherwise the deployed API gateway base.
    if (
      this.config.getConfig().isLocal &&
      this.config.getConfig().localEndpoints &&
      this.config.getConfig().localEndpoints.qualityBoostUrl
    ) {
      this.qualityBoostUrl = this.config.getConfig().localEndpoints.qualityBoostUrl;
    } else {
      this.qualityBoostUrl = this.config.getConfig().apiUrl;
    }
  }

  // getSummary returns a tenant's tier counts, per-signal hit counts, and
  // time-sensitive callout count (REQ-DASH-001). The response is PHI-free.
  getSummary(tenantId: number): Observable<QualityBoostSummary> {
    return this.http.get<QualityBoostSummary>(
      `${
        this.qualityBoostUrl
      }/qualityboost-scoring/tenants/${tenantId.toString()}/summary`
    );
  }

  // getCharts returns a tenant's per-chart tiers (the drill-through detail),
  // optionally narrowed to a single tier. An empty tierFilter returns all tiers.
  getCharts(
    tenantId: number,
    tierFilter?: string
  ): Observable<QualityBoostChartsResponse> {
    let params = new HttpParams();
    if (tierFilter) {
      params = params.set("tier", tierFilter);
    }
    return this.http.get<QualityBoostChartsResponse>(
      `${
        this.qualityBoostUrl
      }/qualityboost-scoring/tenants/${tenantId.toString()}/charts`,
      { params: params }
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/quality-boost/quality-boost.service.ts